import type { HubDeploymentDefinition } from '@robovision/hub'
import { BaseDefinition } from './BaseDefinition'
import { JobRuntimeParameters } from './common/JobRuntimeParameters'


export class DeploymentDefinition extends BaseDefinition<HubDeploymentDefinition> {
  public buildDefaultResources (): JobRuntimeParameters {
    return JobRuntimeParameters.fromRuntimeParameters(
      this.job.services[0]?.runtime,
    )
  }
}
